module.exports = __webpack_public_path__ + "static/media/1.9940fa4e.png";